// Australian state-based shipping rates
// Format: { state: { standard: rate, express: rate } }

export const SHIPPING_RATES = {
  WA: {
    standard: 8.00,
    express: 15.00
  },
  VIC: {
    standard: 12.00,
    express: 20.00
  },
  QLD: {
    standard: 12.00,
    express: 20.00
  },
  SA: {
    standard: 12.00,
    express: 20.00
  },
  NSW: {
    standard: 12.00,
    express: 20.00
  },
  TAS: {
    standard: 15.00,
    express: 22.00
  },
  NT: {
    standard: 18.00,
    express: 30.00
  },
  ACT: {
    standard: 12.00,
    express: 20.00
  }
};

// Free shipping threshold
export const FREE_SHIPPING_THRESHOLD = 100;

// Australian states for dropdown
export const AUSTRALIAN_STATES = [
  { value: 'NSW', label: 'New South Wales' },
  { value: 'VIC', label: 'Victoria' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'SA', label: 'South Australia' },
  { value: 'WA', label: 'Western Australia' },
  { value: 'TAS', label: 'Tasmania' },
  { value: 'NT', label: 'Northern Territory' },
  { value: 'ACT', label: 'Australian Capital Territory' }
];

// Calculate shipping cost
export const calculateShipping = (state: string, method: 'standard' | 'express', cartTotal: number): number => {
  // Free shipping for orders over threshold
  if (cartTotal >= FREE_SHIPPING_THRESHOLD && method === 'standard') {
    return 0;
  }

  const rates = SHIPPING_RATES[state as keyof typeof SHIPPING_RATES];
  if (!rates) {
    return SHIPPING_RATES.NSW.standard; // Default to NSW standard
  }

  return rates[method];
};